import Router from "preact-router"
import { createHashHistory } from "history"
import { render } from "preact"

import { App, ElfsightPopup } from "./utils/fw.js"


const extractElfsightPopupsFromRoom = ({links}) => links.map(link => ([link.elfsightPopupID, link.elfsightPopupTrigger]))
const extractElfsightPopupsFromRooms = room => room.flatMap(extractElfsightPopupsFromRoom).filter(([ID]) => ID != undefined)

const discardElfsightPopupsFromRoom = ({links, ...room}) => ({
	...room,
	links: links.map(
		link => {
			const {elfsightPopupID, elfsightPopupTrigger, ...newLink} = link
			if ([elfsightPopupID, elfsightPopupTrigger].includes(undefined)) return link
			else return {...newLink, onClick: () => document.getElementById(link.elfsightPopupTrigger).click()}
		}
	)
})

const discardElfsightPopupsFromRooms = rooms => rooms.map(discardElfsightPopupsFromRoom)

const splitElfsightPopupsFromRooms = rooms => ([
	extractElfsightPopupsFromRooms(rooms),
	discardElfsightPopupsFromRooms(rooms)
])

export default (rooms = [], options = {}) => {
	const { beforeRoom = null, afterRoom = null } = options
	const [ elfsightPopups, rooms2 ] = splitElfsightPopupsFromRooms(rooms)

	render(<>
		{beforeRoom}
		<Router history={createHashHistory()}>
			{rooms2.map(room => <App {...room} path={room.path || room.roomName.replace(/ /g, "-").replace(/[^A-z-]/g, "")} />)}
		</Router>
		{elfsightPopups && elfsightPopups.length > 0 && elfsightPopups.map(([ID, trigger]) => <ElfsightPopup ID={ID} trigger={trigger}/>)}
		{elfsightPopups && elfsightPopups.length > 0 && <script src="https://apps.elfsight.com/p/platform.js" defer="" />}
		{afterRoom}
	</>, document.getElementById("content"))
}
